import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/layout/badge-app-store.svg")